import { Component } from '@verndale/core';
import { createFocusTrap } from 'focus-trap';
import { KEYS, FOCUSABLE_ELEMENTS } from '../constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $triggers: document._$$(`[data-trigger-modal=${this.el.id}]`),
      $closeButton: this.el._$('.modal__close-button'),
      $backdrop: this.el._$('.modal__backdrop'),
      $content: this.el._$('.modal__content'),
      $body: document.body
    };

    this.focusableModalElements = this.el._$$(FOCUSABLE_ELEMENTS);
    this.focusTrap = createFocusTrap(this.el);

    if (this.el.classList.contains('modal--auto-open')) {
      this.openModal();
    }
  }

  addListeners() {
    this.el._on('keydown', this.handleKeydown.bind(this));
    this.dom.$backdrop?._on('click', this.handleBackdropClick.bind(this));
    this.dom.$closeButton?._on('click', this.closeModal.bind(this));
    this.dom.$triggers?.forEach(el => {
      el._on('click', this.openModal.bind(this));
      el._on('keydown', e => {
        if (e.which === 13) {
          e.preventDefault();
          this.openModal();
        }
      });
    });

    if (this.el.dataset?.detailPage === '') {
      const removeBtn = this.el._$('.remove-member-modal__btn');
      removeBtn?._on('click', this.handleRemoveBtnClick.bind(this));
    }
  }

  handleKeydown({ keyCode }) {
    if (keyCode === KEYS.ESC) {
      this.closeModal();
    }
  }

  handleBackdropClick(e) {
    if (e.target === this.dom.$backdrop) {
      this.closeModal();
    }
  }

  openModal() {
    this.lastFocusedElement = document.activeElement;
    this.focusableModalElements?.forEach(element =>
      element.setAttribute('tabindex', '1')
    );
    this.el.removeAttribute('aria-hidden');
    this.focusTrap.activate();
    this.dom.$body.classList.remove('modal__body-visible');
    this.dom.$body.classList.add('modal__body-hidden');

    if (this.focusableModalElements?.length) {
      this.focusableModalElements[0].focus();
    }

    const event = new Event('modalopen');
    this.el.dispatchEvent(event);
  }

  closeModal() {
    if (this.el._$('.update-contact-modal__error'))
      this.el._$('.update-contact-modal__error').innerHTML = '';
    this.focusTrap.deactivate();
    this.el.setAttribute('aria-hidden', 'true');
    this.dom.$body.classList.remove('modal__body-hidden');
    this.dom.$body.classList.add('modal__body-visible');

    if (this.lastFocusedElement) this.lastFocusedElement.focus();

    const event = new Event('modalclose');
    this.el.dispatchEvent(event);
  }
}

export default Module;
